import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _FixedAssetCatalog } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import { AccountEditor } from '../../../../../../editor/AccountEditor';
import { BasicButton } from '../../../../../../theme/Component/BasicButton';
import usePaginator from '../../../../../../theme/Component/usePaginator';
import { toast } from 'react-toastify';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const    SelectFixedAsset = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_FixedAssetCatalog)
    const [id, setID] = useState(null);
    const [idFixedAsset, setidFixedAsset] = useState<number>(null);
    const [prefix, setprefix] = useState<any>(null);
    const [accountid, setaccountid] = useState<number>(null);
    const [renderValue, setRenderValue] = useState<string>("");

    const modal = useModal("Activos Fijos", MODAL_LG);
    const paginador = usePaginator();


    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDFixedAsset == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {
        instance.getFixedAssetCatalog(idFixedAsset, prefix, accountid, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    setLista(resp.List)
                }
            }
        ).catch(
            (err: any) => {
                toast.error(err)
            }
        )
    }
    const head = [
        { title: 'ID', property: 'IDFixedAsset', visible: true },
        { title: 'Nombre', property: 'Description', visible: true },
        { title: 'Ticpo Documento', property: 'Mnemonic', visible: true },
        { title: 'No Documento', property: 'Consecutive', visible: true },
        { title: 'Fecha Documento', property: 'InitDate', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Activo Fijo"}</label>
            <span className='form-control form-control text-wrap' style={{ minHeight: "35px" }} onClick={abrirModal}>{render ?? renderValue}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal} onSubmitLabel='Seleccionar'>
                <div className="row">
                    <div className="col-md-6">
                        <label>ID de Activo Fijo a Buscar</label>
                        <input type="text" name="idFixedAsset" className="form-control" value={idFixedAsset} onChange={(e) => { setidFixedAsset(parseFloat(e.target.value)) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto*</label>
                        <input type="text" name="prefix" className="form-control" value={prefix} onChange={(e) => { setprefix(e.target.value) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor label="Tercero a quien se le adquirió" idAccount={accountid} onChange={(e) => { setaccountid(e.IDAccount) }}></AccountEditor>
                    </div>
                    <div className="col-md-4 mt-4">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable 
                head={head} 
                body={lista} 
                rowSet={(e) => { 
                    if(e)
                    {
                        setValue(e.IDFixedAsset); 
                        modal.close(); 
                        setRenderValue(  `${e?.IDFixedAsset ?? ''} - ${e?.Description ?? ''}`) 

                    }
                }} 
                    // pageTop={paginador.page}
                    // next={paginador.next}
                    // back={paginador.back}
                    records={paginador} />
            </Modal>
        </>
    )
}